//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import InspectionRecordItemDrawer from "./modules/InspectionRecordItemDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: "InspectionRecordItemList",
  mixins: [JeecgListMixin],
  components: {
    InspectionRecordItemDrawer: InspectionRecordItemDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/inspection/record/item',
      pageTitle: '巡检结果',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'recordId',
        colName: 'record_id',
        title: '巡检记录',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'pointId',
        colName: 'point_id',
        title: '巡检点ID',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'itemId',
        colName: 'item_id',
        title: '巡检项目ID',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'val',
        colName: 'val',
        title: '巡检结果',
        align: "center",
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};